import { createAsyncThunk } from '@reduxjs/toolkit'
import { generateServerSeedService, getTransactions, getUserInfoService, updateRunItTwicePreferenceService } from 'network/services/users.service'

export const fetchUserInformation = createAsyncThunk('user/user-detail', async (_, thunkApi) => {
  try {
    const res = await getUserInfoService()
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const generateServerSeed = createAsyncThunk('user/generate-server-seed', async (_, thunkApi) => {
  try {
    const res = await generateServerSeedService()
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getUserTransactions = createAsyncThunk('user/transactions', async (params, thunkApi) => {
  try {
    const { offset, transactionType, limit } = params
    const res = await getTransactions({ offset, transactionType, limit }, 'user/transaction-list')
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const updateRunItTwicePreferenceThunk = createAsyncThunk(
  'user/updateRunItTwicePreference',
  async (payload, { rejectWithValue }) => {
    try {
      const result = await updateRunItTwicePreferenceService(payload)
      return result ?? payload
    } catch (error) {
      console.error('Error updating run it twice preference:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update preference')
    }
  }
)
